var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.token)?_c('Transfer',{attrs:{"token":_vm.token}}):_vm._e(),(_vm.clickandbuy)?_c('ClickAndBuy',{attrs:{"click-and-buy-i-d":_vm.clickandbuy}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }